<template>
  <svg
    aria-hidden="true"
    focusable="false"
    width="12"
    class="icon icon-shipping-estimator"
    part="icon"
    viewBox="0 0 12 12"
  >
    <path
      stroke-width="1"
      stroke="currentColor"
      fill="none"
      d="M11.5 3.5v8H.5v-8m11 0-2-3H6m5.5 3H6m-5.5 0 2-3H6m-5.5 3H6m0 0v-3"
    ></path>
  </svg>
</template>

